import FlexBox from '@/atomic-components/FlexBox';
import { Box, Slide, Zoom } from '@mui/material';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import ProductImagesSlider from './ProductImagesSlider';
import { Thumbnail } from '../Inclusions/modal';
import { ProductApiData } from '@/services/catalogue/models/pdp';

export interface IImageCarouselComponentProps {
	heroImages: Thumbnail[];
	productDetails: ProductApiData;
}

const ImageCarouselComponent = (props: IImageCarouselComponentProps) => {
	const { heroImages } = props;

	return (
		<FlexBox
			sx={{
				justifyContent: 'center',
				width: '100%',
			}}
		>
			<Box
				sx={{
					width: '100%',
					background: 'linear-gradient(180deg, #FFFFFF 0.09%, #F3F3F3 100%)',
					position: 'relative',
				}}
			>
				{heroImages && (
					<ProductImagesSlider
						productDetails={props.productDetails}
						images={heroImages}
					/>
				)}
			</Box>
		</FlexBox>
	);
};

export default ImageCarouselComponent;
